import { rfqQuoteDetailsMessagesStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

rfqQuoteDetailsMessagesStyles.mainWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        background-color: ${getColor("common.accent")};
        padding: 10px 20px;
        margin-top: 30px;
    `,
};
